export default __webpack_public_path__ + "static/media/Ativo.82102cf2.svg";